import React, {Component} from 'react';


import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Table, Alert } from 'reactstrap';

import { console_log, jsUcfirst, formatDate } from "../../utils/helper";


class Country extends Component {
    render() {
        return(
            <div className="country animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Country</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="country">Country Name</Label>
                                        </Col>
                                        <Col xs="12" md="9" size="lg">
                                            <Input type="select" name="country" id="country">
                                                <option key={0} value={0}>Country Name</option>
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="languages">Multiple select</Label>
                                        </Col>
                                        <Col md="9">
                                            <Input type="select" name="languages" id="languages" defaultValue={[]} multiple>
                                                <option key={0} value={0}>English</option>
                                                <option key={1} value={0}>Hindi</option>
                                                <option key={2} value={0}>Marathi</option>
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    <Alert color="danger"></Alert>
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary"><i className="fa fa-check"></i> Add</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Table hover responsive size="lg" className="country-custom-table">
                                    <thead>
                                        <tr>
                                            <th>Country</th>
                                            <th>Language</th>
                                            <th>Domain</th>
                                            <th>Sub-Domain</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>India</strong></td>
                                            <td><span className="gray-highlight">EN</span></td>
                                            <td><span className="mr-2"> </span></td>
                                            <td><span className="green-highlight">sam</span><span className="green-highlight">my</span></td>
                                            <td>
                                                <Button size="sm" color="success">
                                                    <i className="fa fa-edit"></i>
                                                </Button>
                                                <Button size="sm"  color="danger">
                                                    <i className="fa fa-trash"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5}>
                                                No Countries added yet.
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Country;


// WEBPACK FOOTER //
// ./src/components/Country/Country.js